/**
 * Standard-Schlusstext (Textvorlagen → Schlusstext) für Angebote und Rechnungen.
 * Must stay in sync with the sentence in migration 20260930150000_followup_closing_text_default.sql
 */
export const FOLLOWUP_QUESTIONS_SENTENCE = 'Für Rückfragen stehen wir Ihnen gerne zur Verfügung.';

/** Drops template closing lines that an older draft already carries as after-totals paragraph. */
export function withoutDuplicateClosingTexts(closingTexts: readonly string[], existingTexts: readonly string[]): string[] {
  const existing = new Set(existingTexts.map((t) => t.trim()));
  return closingTexts.filter((t) => !existing.has(t.trim()));
}
